<nz-drawer
  [nzBodyStyle]="{ overflow: 'auto' }"
  [nzMaskClosable]="false"
  [nzWidth]="550"
  [nzVisible]="isVisibleAgencyDrawer"
  [nzTitle]="agencyDrawerTitle"
  [nzFooter]="footerTpl"
  (nzOnClose)="handleCancel()"
>
  <form nz-form *nzDrawerContent [formGroup]="_fS.agencysForm">
    
    <!-- nzMultiple="false"
    (click)="file.click()"
    (change)="onFileChanged($event, false)" -->
    <div class="upload">
      <div
      >
        <button
          nz-button
          (click)="file.click()"
          [nzLoading]="isLoadingUploadSiteLogo"
          class="update-logo-btn"
        >
          <i nz-icon nzType="camera" nzTheme="outline"></i>
          Add/Update Logo for Site
        </button>
      </div>
      <input
        autocomplete="off"
        type="file"
        (change)="onFileChanged($event, false)"
        #file
        hidden
        nzTooltipTitle="prompt text"
        accept="image/*"
      />
      <a
        *ngIf="this.uploadResultSiteLogo"
        nz-popconfirm
        nzPopconfirmTitle="Are you sure you want to delete the logo?"
        nzPopconfirmPlacement="bottom"
        (nzOnConfirm)="removeLogo(false)"
        ><img
          src="../../../../assets/images/delete.png"
          class="delete-File ml-1"
        />
      </a>
    </div>
    <div class="d-flex align-i-c">
      <!-- <nz-avatar
        [nzShape]="'square'"
        class="mr-1"
        (click)="file.click()"
        [nzSrc]="this.uploadResultSiteLogo ? this.uploadResultSiteLogo : null"
        [nzText]="'Site'"
        [nzSize]="140"
      ></nz-avatar> -->
      <img *ngIf="uploadResultSiteLogo" [src]="this.uploadResultSiteLogo" alt="Site Image"  style="max-width: 75%;" />

      <button
        *ngIf="uploadResultSiteLogo && siteLogoFile && !siteImageResized"
        class="tex-btn ml-1"
        nz-button
        nzMultiple="false"
        nzType="text"
        (click)="uploadResizedImage(siteLogoFile, 140, 60)"
      >
        <i nz-icon nzType="compress" nzTheme="outline"></i>
        Resize
      </button>
    </div>

    <div class="upload mt-1">
      <div
      >
        <button
          nz-button
          [nzLoading]="isLoadingUploadReportLogo"
          class="update-logo-btn"
          (click)="fileReport.click()"
        >
          <i nz-icon nzType="camera" nzTheme="outline"></i>
          Add/Update Logo for Report
        </button>
      </div>
      <input
        autocomplete="off"
        type="file"
        (change)="onFileChanged($event, true)"
        #fileReport
        hidden
        nzTooltipTitle="prompt text"
        accept="image/*"
      />
      <a
        *ngIf="this.uploadResultReportLogo"
        nz-popconfirm
        nzPopconfirmTitle="Are you sure you want to delete the logo?"
        nzPopconfirmPlacement="bottom"
        (nzOnConfirm)="removeLogo(true)"
        ><img
          src="../../../../assets/images/delete.png"
          class="delete-File ml-1"
        />
      </a>
    </div>
    
    <!-- [nzGap]="100"
    [nzSize]="60" -->
    <div class="d-flex align-i-c">
      <!-- <nz-avatar
        [nzShape]="'square'"
        (click)="fileReport.click()"
        (change)="onFileChanged($event, true)"
        [nzText]="'Report'"
        class="mr-1"
        [nzSrc]="
          this.uploadResultReportLogo ? this.uploadResultReportLogo : null
        "
        style="width: 140px !important;height:auto"
      ></nz-avatar> -->
      <img *ngIf="uploadResultReportLogo" [src]="this.uploadResultReportLogo" alt="Report Image"  style="max-width: 75%;" />
      <button
        *ngIf="uploadResultReportLogo && reportLogoFile && !reportImageResized"
        class="tex-btn ml-1"
        nz-button
        nzMultiple="false"
        nzType="text"
        (click)="uploadResizedReportImage(reportLogoFile, 180, 80)"
      >
        <i nz-icon nzType="compress" nzTheme="outline"></i>
        Resize
      </button>
    </div>
    <div nz-row [nzGutter]="8">
      <div nz-col nzSpan="24">
        <nz-form-item>
          <nz-form-control [nzErrorTip]="agencyNameError">
            <label class="label-text required">Agency name</label>
            <input
              type="text"
              pattern="^(?!\s+$).+"
              class="input-group"
              nz-input
              formControlName="agencyName"
              maxlength="50"
              minlength="2"
              (keypress)="_cs.checkAlphabetsWithSpaceCommaNumbers($event)"
            />
            <ng-template #agencyNameError let-control>
              <ng-container *ngIf="control.hasError('required')"
                >Please enter agency name</ng-container
              >
              <ng-container *ngIf="control.hasError('minlength')"
                >Agency name must contain at least 2 characters</ng-container
              >
              <ng-container *ngIf="control.hasError('pattern')"
                >Please enter agency name</ng-container
              >
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row [nzGutter]="15">
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-control [nzErrorTip]="lightColorError">
            <label class="label-text required">Light color</label>
            <div class="d-flex align-i-c">
              <div
                class="color picker-box d-flex align-i-c"
                [ngStyle]="{
                  border:
                    this.lightColorValidationColor == 'INVALID'
                      ? '1px solid red'
                      : ''
                }"
              >
                <span
                  class="color-name"
                  [ngStyle]="{ 'background-color': lightColorStyle }"
                ></span>
                <input
                  class="input-group color-input"
                  nz-input
                  formControlName="lightColor"
                  type="color"
                  [(ngModel)]="lightColorStyle"
                  (Change)="applyColorlightColor()"
                />
                <span class="color-picker-icon"
                  ><img src="assets/images/color-picker-icon .svg"
                /></span>
              </div>
            </div>
            <ng-template #lightColorError let-control>
              <ng-container *ngIf="control.hasError('required')"
                >Please select light color</ng-container
              >
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-control [nzErrorTip]="darkColorError">
            <label class="label-text required">Dark color</label>
            <div class="d-flex align-i-c">
              <div
                class="color picker-box d-flex align-i-c"
                [ngStyle]="{
                  border:
                    this.darkColorValidationColor == 'INVALID'
                      ? '1px solid red'
                      : ''
                }"
              >
                <span
                  class="color-name"
                  [ngStyle]="{ 'background-color': darkColorStyle }"
                ></span>
                <input
                  class="input-group color-input"
                  nz-input
                  formControlName="darkColor"
                  type="color"
                  [(ngModel)]="darkColorStyle"
                  (Change)="applyColordarkColor()"
                />
                <span class="color-picker-icon"
                  ><img src="assets/images/color-picker-icon .svg"
                /></span>
              </div>
            </div>
            <ng-template #darkColorError let-control>
              <ng-container *ngIf="control.hasError('required')"
                >Please select dark color</ng-container
              >
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row [nzGutter]="8">
      <div nz-col nzSpan="24">
        <nz-form-item class="margin-none">
          <nz-form-control class="switch-box">
            <nz-switch formControlName="isActiveagency"></nz-switch>
            <label class="switch-label black mr-1">{{
              _fS.agencysForm.get("isActiveagency").value
                ? "Active"
                : "Inactive"
            }}</label>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
  </form>
  <ng-template #footerTpl>
    <div class="d-flex justify-content-end">
      <button
        nz-button
        nzType="primary"
        (click)="handleOk()"
        [nzLoading]="isLoadingOne"
        class="medium-btn small-btn width-100 mr-1"
      >
        {{ selectedAgencyData != null ? "Update" : "Add" }}
      </button>
      <button
        nz-button
        nzType="default"
        (click)="handleCancel()"
        class="dlt-btn width-100"
      >
        Cancel
      </button>
    </div>
  </ng-template>
</nz-drawer>
